<template>
  <div class="order-card tw-text-sm tw-bg-slate-100 tw-p-2 tw-rounded-md">
    <div class="tw-flex tw-justify-between">
      <div class="id">
        Order ID: <span class="tw-text-primary-light">{{ order.orderId }}</span>
      </div>
      <div class="id">
        <span class="tw-text-primary-light tw-font-bold">{{ status }}</span>
      </div>
    </div>
    <div class="tw-flex tw-justify-between">
      <div class="price">
        Price:
        <span class="tw-text-primary-light">{{
          grandTotal | formatedPrice
        }}</span>
      </div>
      <div class="item-count">
        <span class="tw-text-primary-light"
          >{{ itemCount }} {{ itemCount > 1 ? "items" : "item" }}</span
        >
      </div>
    </div>
    <div class="shipping-type">
      Type:
      <span class="tw-text-primary-light">{{ shippingType }}</span>
    </div>
    <div class="status">
      Delivery On: <span class="tw-text-primary-light">{{ formatedDate }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(localizedFormat);

export default {
  name: "OrderCard",
  props: {
    order: Object,
  },
  computed: {
    status() {
      if (this.order.payment) {
        return this.order.payment.isPaid ? "Paid" : "Cancelled";
      }
      return this.order.isPaid ? "Paid" : "Cancelled";
    },
    shippingType() {
      if (this.order.shipping) {
        return this.order.shipping.shippingType;
      }
      return undefined;
    },
    grandTotal() {
      if (this.order) {
        if (this.order.payment) {
          if (this.order.payment.grandTotal >= 0) {
            return this.order.payment.grandTotal;
          }
        }
      }
      if (this.order) {
        if (this.order.grandTotal) {
          return this.order.grandTotal;
        }
      }
      return "";
    },
    itemCount() {
      let count = 0;
      if (this.order.productList) {
        count = this.order.productList.reduce((acc, i) => {
          return acc + i.quantity;
        }, 0);
      }
      return count;
    },
    formatedDate() {
      return dayjs(this.order?.shipping?.scheduleList[0]?.dateTime).format(
        "LL"
      );
    },
  },
  filters: {
    formatedPrice(price) {
      return `฿${price.toLocaleString()}`;
    },
  },
};
</script>

<style>

</style>
